import React from 'react';
import MainSection from 'frontend/components/home/MainSection';
import BannersComponents from 'frontend/components/home/BannersComponents';
import logowhatsapp from '../../assets/images/logo-whatsapp.png';
import { useSelector } from 'react-redux';

const HomeView = () => {
  const footerElements = useSelector((state) => state.applicationState.templateData.footer.detalle);
  const numWhatsapp = footerElements.find(
    (footerElements) =>
      footerElements.tipoEnlace?.nombre === 'whatsapp' && footerElements.valor !== '',
  );
  return (
    <>
      <MainSection />
      <BannersComponents />
      {numWhatsapp && (
        <a
          href={`https://api.whatsapp.com/send/?phone=${numWhatsapp.valor}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={logowhatsapp}
            alt="Icono"
            style={{
              position: 'fixed',
              bottom: '15px',
              right: '15px',
              cursor: 'pointer',
              zIndex: '99999999',
              height: '50px',
              width: '50px',
            }}
          />
        </a>
      )}
    </>
  );
};

export default HomeView;
